import { Injectable } from '@angular/core';
// CRUD
import { HttpUtilsService, QueryParamsModel, QueryResultsModel } from '../../../core/_base/crud';
// Models
import { User } from '../../../core/auth/_models/user.model';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import {map} from 'rxjs/operators';
import { Observer, Subject, from } from 'rxjs';
import { BehaviorSubject } from 'rxjs';
import * as io from 'socket.io-client';


const API_UserS_URL = '/api/user';
const socket = io('http://estimator.kikblox.com:3000');
@Injectable({
  providedIn: 'root'
})





export class UserService {
  private userId: string;
  private isActive: boolean = false;
  private logoUploadedSubject: Subject<string> = new Subject<string>();
  constructor(private http: HttpClient, private httpUtils: HttpUtilsService) {
    //http://localhost:3000
    //http://54.224.133.189:3000
    //http://estimator.kikblox.com:3000
  }

  // CREATE =>  POST: add a new User to the server
  createUser(user: User): Observable<User> {
    console.log(user);
    // Note: Add headers if needed (tokens/bearer)
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    return this.http.post<User>(API_UserS_URL, user, {headers: httpHeaders, responseType: 'text' as 'json'});
  }








  // READ
  getAllUsers(): Observable<User[]> {
    return this.http.get<User[]>(API_UserS_URL);
   
  }
  getLogeduserCompany(UserId: string): Observable<User> {
    return this.http.get<User>(API_UserS_URL + `/userCompany` + `/${UserId}`);
  }
  getUserById(UserId: string): Observable<User> {
    return this.http.get<User>(API_UserS_URL + `/${UserId}`);
  }

  // Method from server should return QueryResultsModel(items: any[], totalsCount: number)
  // items => filtered/sorted result
  // Server should return filtered/sorted result
  findUsers(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
    // Note: Add headers if needed (tokens/bearer)
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const httpParams = this.httpUtils.getFindHTTPParams(queryParams);

    const url = API_UserS_URL + '/find';
    return this.http.get<QueryResultsModel>(url, {
      headers: httpHeaders,responseType: 'text' as 'json',
      params: httpParams
    });
  }

  // UPDATE => PUT: update the User on the server
  updateUser(User: User): Observable<any> {
    const httpHeader = this.httpUtils.getHTTPHeaders();
    return this.http.put(API_UserS_URL + `/${User.uuid}`, User, {headers: httpHeader, responseType: 'text' as 'json'});
  }

  // UPDATE Status
  updateStatusForUser(Users: User[], status: number): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const body = {
      UsersForUpdate: Users,
      newStatus: status
    };
    const url = API_UserS_URL + '/updateStatus';
    return this.http.put(url, body, {headers: httpHeaders, responseType: 'text' as 'json'});
  }

  // DELETE => delete the User from the server
  deleteUser(UserId: string): Observable<User> {
    const url = `${API_UserS_URL}/${UserId}`;
    return this.http.delete<User>(url);
  }

  deleteUsers(ids: string[] = []): Observable<any> {
    const url = API_UserS_URL + '/deleteUsers';
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const body = {UserIdsForDelete: ids};
    return this.http.put<QueryResultsModel>(url, body, {headers: httpHeaders, responseType: 'text' as 'json'});
  }
  getUserByEmail(email: string): Observable<User> {
    const url = `${API_UserS_URL}/getByEmail/${email}`;
    return this.http.get<User>(url);
  }
  getUsersByDistributionCompanyName(distributorCompanyName: string): Observable<User[]> {
    const url = `${API_UserS_URL}/getUsersByDistributionCompanyName/${distributorCompanyName}`;
    return this.http.get<User[]>(url);
  }
  assignRole(userId: string, role: string): Observable<any> {
    const url = `${API_UserS_URL}/assign-role`;
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const body = {
      userId,
      role
    };
    return this.http.post(url, body, { headers: httpHeaders, responseType: 'text' as 'json' });
  }
  getKikMembers(IsKikMember:boolean): Observable<User[]> {
    const url = `${API_UserS_URL}/getKikMembers/${IsKikMember}`;
    return this.http.get<User[]>(url);
   
  }
  getDirectCustomers(isDirectCustomer:boolean): Observable<User[]> {
    const url = `${API_UserS_URL}/getDirectCustomers/${isDirectCustomer}`;
    return this.http.get<User[]>(url);
  }
  sendEmail(email: string): Observable<any> {
    const url = `${API_UserS_URL}/send-email`;
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const body = {
      email
    };
    return this.http.post(url, body, { headers: httpHeaders, responseType: 'text' as 'json' });
  }
  resetPassword(email: string, newPassword: string): Observable<any> {
    const url = `${API_UserS_URL}/reset-password`; 
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const body = {
      email,
      newPassword
    };
    return this.http.post(url, body, { headers: httpHeaders, responseType: 'text' as 'json' });
  }
  loginUser(userId: string) {
    if (!this.isActive && userId) {
      this.userId = userId; // Store the user ID
      socket.emit('login', userId);
      this.isActive = true;
    }
  }
  
  logoutUser() {
    if (this.isActive && this.userId) {
      socket.emit('logout', this.userId); // Pass userId to the 'logout' event
      this.isActive = false;
    }
  }

initSocket(): Observable<any> {
    return new Observable((observer: Observer<any>) => {
      socket.on('updateUsers', (data: { userId: string, isActive: boolean }) => {
        observer.next(data); // Emit the received data
      });
    });
}
uploadUserLogo(userId: string, logoFile: File): Observable<string> {
  return new Observable<string>((observer) => {
    // Use FileReader to read the file data as a base64 string
    const reader = new FileReader();
    reader.onload = () => {
      const base64String = reader.result as string; // Ensure reader result is of type string
      const compressedImage = this.compressBase64Image(base64String);

      // Send the base64 encoded image data to the backend
      const uploadUrl = `${API_UserS_URL}/${userId}/logo`;
      this.http.post<string>(uploadUrl, { base64Image: compressedImage }).subscribe(
        (response: string) => {
          this.logoUploadedSubject.next(base64String); // Emit event for logo upload
          observer.next(response);
          observer.complete();
        },
        (error: any) => {
          observer.error(error);
        }
      );
    };

    // Read the logo file as a data URL (base64 encoded)
    reader.readAsDataURL(logoFile);
  });
}
private compressBase64Image(base64String: string, maxWidth: number = 200, maxHeight: number = 200, quality: number = 0.8): string {
  const img = new Image();
  img.src = base64String;

  const canvas = document.createElement('canvas');
  let width = img.width;
  let height = img.height;

  // Calculate new dimensions while preserving aspect ratio
  if (width > maxWidth) {
    height *= maxWidth / width;
    width = maxWidth;
  }
  if (height > maxHeight) {
    width *= maxHeight / height;
    height = maxHeight;
  }

  canvas.width = width;
  canvas.height = height;

  const ctx = canvas.getContext('2d');
  if (!ctx) {
    throw new Error('Unable to create canvas context');
  }

  // Draw image onto canvas with the new dimensions
  ctx.drawImage(img, 0, 0, width, height);

  // Get the compressed base64 image from the canvas
  return canvas.toDataURL('image/jpeg', quality);
}



getUserLogo(userId:string): Observable<string> {
  const apiUrl = `${API_UserS_URL}/${userId}/getLogo`;
  return this.http.get<string>(apiUrl);
}
subscribeToLogoUploaded(): Observable<string> {
  return this.logoUploadedSubject.asObservable();
}

getUsersByCompany(isKikMember: boolean, distributorCompanyName: string, companyName: string): Observable<User[]> {
  const url = `${API_UserS_URL}/getUsersByCompany/${isKikMember}/${distributorCompanyName}/${companyName}`;
  return this.http.get<User[]>(url);
}
getUsersByCompanyName(companyName: string): Observable<User[]> {
  return this.getUsersByDistributionCompanyName(companyName);
}

getEltechUsers(): Observable<User[]> {
  return this.getUsersByDistributionCompanyName('Eltech');
}
}
